import { render, staticRenderFns } from "./NavbarMenuItem.vue?vue&type=template&id=b2de0ccc&scoped=true"
import script from "./NavbarMenuItem.vue?vue&type=script&lang=ts"
export * from "./NavbarMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./NavbarMenuItem.vue?vue&type=style&index=0&id=b2de0ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2de0ccc",
  null
  
)

export default component.exports